import { StyleSheet } from 'react-native';

/** 默认配置 */
export const DEFAULTS = {
    activeColor: '#FF4D4F',
    activeTextColor: '#FF4D4F',
    activeBackgroundColor: '#FFF1F0',
    borderColor: '#E8E8E8',
    backgroundColor: '#FFFFFF',
    textColor: '#333333',
    disabledTextColor: '#CCCCCC',
    disabledBackgroundColor: '#F5F5F5',
    borderRadius: 20,
    borderWidth: 1,
    fontSize: 13,
    gap: 10,
    paddingHorizontal: 16,
    paddingVertical: 8,
};

export const createStyles = () =>
    StyleSheet.create({
        container: {
            flexDirection: 'row',
            flexWrap: 'wrap',
        },
        item: {
            alignItems: 'center',
            justifyContent: 'center',
            borderWidth: DEFAULTS.borderWidth,
            borderColor: DEFAULTS.borderColor,
            backgroundColor: DEFAULTS.backgroundColor,
            borderRadius: DEFAULTS.borderRadius,
            paddingHorizontal: DEFAULTS.paddingHorizontal,
            paddingVertical: DEFAULTS.paddingVertical,
        },
        itemSelected: {
            borderColor: DEFAULTS.activeColor,
            backgroundColor: DEFAULTS.activeBackgroundColor,
        },
        itemDisabled: {
            backgroundColor: DEFAULTS.disabledBackgroundColor,
            borderColor: '#E8E8E8',
        },
        text: {
            fontSize: DEFAULTS.fontSize,
            color: DEFAULTS.textColor,
            textAlign: 'center',
        },
        textSelected: {
            color: DEFAULTS.activeTextColor,
        },
        textDisabled: {
            color: DEFAULTS.disabledTextColor,
            textDecorationLine: 'line-through',
        },
    });
